module.exports = __webpack_public_path__ + "media/images/application/template/icon-close-7d43b933dcf25f9487290bea65a25a8e.svg";